<template>
  <div :class="['letter-avatar', extraClass]">
    {{ getInitials }}
  </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: '',
        },
        extraClass: {
            type: String,
            default: '',
        },
    },
    computed: {
        getInitials() {
            let initials = '';
            const words = this.label.split(' ');
            words.forEach((word, index) => {
                if (index < 3) {
                    initials += word.charAt(0);
                }
            });

            return initials;
        },
    },
};
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/utils/_variables.scss";
  .letter-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-color: #B1B7BE;
    color: #2A3E53;
    text-align: center;
    border: 2px solid #FFFFFF;
    font-size: 12px;
  }
  .darken {
    background-color: white;
    border: 2px solid $primary-color;
  }
</style>
